module.exports = __webpack_public_path__ + "static/media/agentLoanIcon.59c6c8e8.svg";